// `image.layerize`: live's Layerize (G13, #251), one picture split into its layers.
// Live's label map; the composer's Layerize mode builds the body (its web PR).
import { ImageLayerizeQuote, ImageLayerizeRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"image.layerize"> = {
  type: "image.layerize",
  label: "Layerize",
  source: "form",
  pair: "image.layerize",
  fields: () => ({}),
  request: ImageLayerizeRequest,
  quote: ImageLayerizeQuote,
};
